import React from "react";

// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";

import { PlusIcon } from "~/assets/svg/MathIcon";
import { SolidCloseIcon } from "~/assets/svg/CloseIcon";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { Trans, useTranslation } from "react-i18next";

const ProcessTwo = ({
	categories,
	categoryName,
	addCategories,
	setCatrgoryName,
	deleteItem,
	selectedCategoryIdx,
	showCategoryItems,
	deleteCategory,
	categoryItems,
	setItemName,
	itemName,
	addItem,
}) => {
	const { t } = useTranslation();
	return (
		<>
			<div className="setting-main-category">
				<h3 className="step-title">
					<Trans
						i18nKey={
							"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.step01"
						}
						components={[<b></b>]}
					/>
				</h3>
				<div className="c__card">
					<div className="f__group-row">
						<div className="f__group">
							<div className="f__control">
								<input
									className="c__input"
									placeholder={t(
										"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.placeholder01"
									)}
									value={categoryName || ""}
									onChange={(e) => setCatrgoryName(e.target.value)}
								/>
							</div>
						</div>
						<button
							type="button"
							className="dashed-btn plus-btn"
							onClick={addCategories}
							disabled={categoryName === ""}
						>
							<PlusIcon />
							{t(
								"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.add"
							)}
						</button>
					</div>
					<ul className="category-list">
						{categories.length !== 0 ? (
							categories.map((d, idx) => (
								<li
									className={`category-item ${
										d.idx === selectedCategoryIdx ? "active" : ""
									}`}
									key={d.idx}
									onClick={() => showCategoryItems(d.idx)}
								>
									<p className="category-content">{d.title}</p>
									<button type="button" onClick={() => deleteCategory(idx)}>
										<SolidCloseIcon />
									</button>
								</li>
							))
						) : (
							<li className="no-content">
								<CautionIcon />
								{t(
									"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.noContents01"
								)}
							</li>
						)}
					</ul>
				</div>
			</div>
			<div className="setting-sub-category">
				<h3 className="step-title">
					<Trans
						i18nKey={
							"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.step02"
						}
						components={[<b></b>]}
					/>
				</h3>
				<div className="c__card">
					<div className="f__group-row">
						<div className="f__group">
							<div className="f__control">
								<input
									className="c__input"
									placeholder={t(
										"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.placeholder02"
									)}
									value={itemName}
									disabled={categories.length === 0}
									onChange={(e) => setItemName(e.target.value)}
								/>
							</div>
						</div>
						<button
							type="button"
							className="dashed-btn plus-btn"
							disabled={categories.length === 0 || itemName === ""}
							onClick={addItem}
						>
							<PlusIcon />
							{t(
								"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.add"
							)}
						</button>
					</div>
					<ul className="category-list">
						{categories.length === 0 ? (
							<li className="no-content">
								<CautionIcon />
								{t(
									"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.noContents02"
								)}
							</li>
						) : categoryItems.length !== 0 ? (
							categoryItems.map((d) => (
								<li className="category-item" key={d.idx}>
									<p className="category-content">{d.content}</p>
									<button type="button" onClick={() => deleteItem(d.idx)}>
										<SolidCloseIcon />
									</button>
								</li>
							))
						) : (
							<li className="no-content">
								<CautionIcon />
								{t(
									"pages.investment.InvestSettingPage.processingModal.contents.ProcessTwo.noContents03"
								)}
							</li>
						)}

						{/* {categoryItems.length !== 0 ? 
									categoryItems.map(d => (
										<li className="category-item" key={d.idx}>
											<p className="category-content">{d.content}</p>
											<button type="button" onClick={() => deleteItem(d.idx)}>
												<SolidCloseIcon  />
											</button>
										</li>
									))
									:
									<li className="no-content">
										<CautionIcon/>
										평가항목을 등록해주세요.
									</li>
								} */}

						{/* <li className="category-item">
									<p className="category-content">test1 카테고리</p>
									<button type="button">
										<SolidCloseIcon />
									</button>
								</li>
								<li className="category-item">
									<p className="category-content">test1 카테고리</p>
									<button type="button">
										<SolidCloseIcon />
									</button>
								</li> */}
						{/* <li className="no-content">
										<CautionIcon/>
										평가항목을 등록해주세요.
									</li> */}
					</ul>
				</div>
			</div>
		</>
	);
};

export default ProcessTwo;
